"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var PremiumMove = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M19.7843055,13.0885912 L19.8535534,13.1464466 L23.2071068,16.5 L19.8535534,19.8535534 C19.6582912,20.0488155 19.3417088,20.0488155 19.1464466,19.8535534 C18.9728803,19.679987 18.9535951,19.4105626 19.0885912,19.2156945 L19.1464466,19.1464466 L21.292,17 L16,17 L16,16 L21.292,16 L19.1464466,13.8535534 C18.9728803,13.679987 18.9535951,13.4105626 19.0885912,13.2156945 L19.1464466,13.1464466 C19.320013,12.9728803 19.5894374,12.9535951 19.7843055,13.0885912 Z M14,17 L14,18 L6,18 L6,17 L14,17 Z M6.5,6 C6.77614237,6 7,6.22385763 7,6.5 L7,7 C7,8.1045695 7.8954305,9 9,9 C10.1045695,9 11,8.1045695 11,7 L11,6.5 C11,6.22385763 11.2238576,6 11.5,6 L12.5,6 C12.7761424,6 13,6.22385763 13,6.5 L13,7 C13,8.1045695 13.8954305,9 15,9 C16.1045695,9 17,8.1045695 17,7 L17,6.5 C17,6.22385763 17.2238576,6 17.5,6 L18.5552158,6.00305813 C18.8296692,6.03355296 19.0274367,6.28076235 18.9969419,6.55521576 L18.502,11 L17.496,11 L17.830699,7.99601686 C17.4199893,9.16328941 16.3077068,10 15,10 C13.3431458,10 12,8.65685425 12,7 C12,8.65685425 10.6568542,10 9,10 C7.69229324,10 6.58001072,9.16328941 6.16930105,7.99601686 L6.9475214,15 L14,14.999 L14,15.999 L6.0524786,16 L5,6.5 C5,6.22385763 5.22385763,6 5.5,6 L6.5,6 Z" })));
};
PremiumMove.displayName = 'PremiumMove';
exports.default = PremiumMove;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=PremiumMove.js.map